type AssemblyWithModel = {
  model?: {
    name?: string | null;
    backflowAssemblyMake?: {
      name?: string | null;
    } | null;
  } | null;
};

export const assemblyModelLabel = (
  assembly?: AssemblyWithModel | null
): string | undefined => {
  const make = assembly?.model?.backflowAssemblyMake?.name;
  const model = assembly?.model?.name;

  return make && model ? `${make} ${model}` : undefined;
};
